"use client"
import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import { RenderConfig, VideoLibraryProps } from "./RenderConfig"

export const VideoLibrary: ComponentConfig<VideoLibraryProps> = {
  label: "Video Library",
  fields: {
    items: {
      label: "List items",
      type: "array",
      getItemSummary: (Items, index = 0) => `Items: ${index + 1}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        title: {
          label: "Title",
          type: "text",
        },
        url: {
          label: "Link",
          type: "text",
        },
      },
    },
  },
  defaultProps: {
    items: [
      {
        id: 1,
        url: "/BWAsU3W7_p8",
        title: "SKYLINE - TRƯỜNG HỌC ĐIỂN HÌNH",
      },
      {
        id: 2,
        url: "/YOF9Yub_w7s",
        title: "SKYLINE - TRƯỜNG HỌC ĐIỂN HÌNH",
      },
      {
        id: 3,
        url: "/nNXoUl0hyVM",
        title: "SKYLINE - TRƯỜNG HỌC ĐIỂN HÌNH",
      },
      {
        id: 4,
        url: "/QqfMr_U1yMk",
        title: "SKYLINE - TRƯỜNG HỌC ĐIỂN HÌNH",
      },
      {
        id: 5,
        url: "/zAilNErO0-4",
        title: "SKYLINE - TRƯỜNG HỌC ĐIỂN HÌNH",
      },
      {
        id: 6,
        url: "/prAtNzJ72Fo",
        title: "SKYLINE - TRƯỜNG HỌC ĐIỂN HÌNH",
      },
      {
        id: 7,
        url: "/VXEKq36c0gU",
        title: "SKYLINE - TRƯỜNG HỌC ĐIỂN HÌNH",
      },
      {
        id: 8,
        url: "/3p9Y0Ti5q6k",
        title: "SKYLINE - TRƯỜNG HỌC ĐIỂN HÌNH",
      },
      {
        id: 9,
        url: "/bhhvmXOcYqw",
        title: "SKYLINE - TRƯỜNG HỌC ĐIỂN HÌNH",
      },
    ],
    height: 500,
  },
  ...RenderConfig,
}
